var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row['status'] === 1)?_c('i',{staticClass:"el-icon-circle-check",staticStyle:{"color":"green"}}):_c('i',{staticClass:"el-icon-circle-close",staticStyle:{"color":"red"}})])}
var staticRenderFns = []

export { render, staticRenderFns }